<template>
  <v-snackbar :timeout="0" v-model="value" top color="error">
    {{ text }}
    <v-icon>error</v-icon>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: Boolean,
    text: String,
    fixed: {
      type: Boolean,
      required: false,
      default: false
    },
    time: {
      type: Number,
      required: false,
      default: 3000
    }
  },
  watch: {
    value() {
      if (this.value && !this.fixed) {
        var v = this;
        setTimeout(() => {
          v.close();
        }, this.time);
      }
    }
  },
  methods: {
    close() {
      this.$emit("input", !this.value);
    }
  }
};
</script>

<style>
</style>
